(function () {
  const productDataElement = document.querySelector('[data-recently-viewed-product]');
  if (!productDataElement) return;

  try {
    const productData = JSON.parse(productDataElement.textContent);
    let recentlyViewed = JSON.parse(localStorage.getItem('recentlyViewed') || '[]');

    recentlyViewed = recentlyViewed.filter((item) => item.handle !== productData.handle);
    recentlyViewed.unshift(productData);

    localStorage.setItem('recentlyViewed', JSON.stringify(recentlyViewed.slice(0, 6)));
  } catch (error) {
    console.warn('Recently viewed product could not be saved.', error);
  }
})();
